export const RECORD_SOURCE_ID = 'landport-records'
export const RECORD_CLUSTER_LAYER_ID = 'landport-records-clusters'
export const RECORD_CLUSTER_COUNT_LAYER_ID = 'landport-records-cluster-count'
export const RECORD_POINT_LAYER_ID = 'landport-records-points'
export const RECORD_LABEL_LAYER_ID = 'landport-records-labels'

const markerInitials = (name) => String(name || '')
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((part) => part[0])
  .join('')
  .toUpperCase()

export const recordFeatureCollection = ({ opportunities = [], parcels = [], selectedRecord = null } = {}) => ({
  type: 'FeatureCollection',
  features: [
    ...opportunities.map((record) => recordFeature('opportunity', record, selectedRecord)),
    ...parcels.map((record) => recordFeature('parcel', record, selectedRecord))
  ].filter(Boolean)
})

export const recordSourceDefinition = (data) => ({
  type: 'geojson',
  data,
  cluster: true,
  clusterRadius: 44,
  clusterMaxZoom: 10,
  promoteId: 'featureId'
})

export const recordClusterLayerDefinition = () => ({
  id: RECORD_CLUSTER_LAYER_ID,
  type: 'circle',
  source: RECORD_SOURCE_ID,
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': '#0f766e',
    'circle-radius': ['step', ['get', 'point_count'], 18, 10, 23, 50, 29],
    'circle-opacity': 0.88,
    'circle-stroke-color': '#ffffff',
    'circle-stroke-width': 2
  }
})

export const recordClusterCountLayerDefinition = () => ({
  id: RECORD_CLUSTER_COUNT_LAYER_ID,
  type: 'symbol',
  source: RECORD_SOURCE_ID,
  filter: ['has', 'point_count'],
  layout: {
    'text-field': ['get', 'point_count_abbreviated'],
    'text-size': 12
  },
  paint: {
    'text-color': '#ffffff'
  }
})

export const recordPointLayerDefinition = () => ({
  id: RECORD_POINT_LAYER_ID,
  type: 'circle',
  source: RECORD_SOURCE_ID,
  filter: ['!', ['has', 'point_count']],
  paint: {
    'circle-color': [
      'match',
      ['get', 'tone'],
      'green',
      '#10b981',
      'emerald',
      '#10b981',
      'amber',
      '#f59e0b',
      'yellow',
      '#f59e0b',
      'red',
      '#ef4444',
      'rose',
      '#ef4444',
      'blue',
      '#2563eb',
      '#64748b'
    ],
    'circle-radius': ['case', ['get', 'selected'], 12, ['==', ['get', 'kind'], 'parcel'], 7, 9],
    'circle-stroke-color': ['case', ['get', 'selected'], '#111827', '#ffffff'],
    'circle-stroke-width': ['case', ['get', 'selected'], 3, 1.5],
    'circle-opacity': 0.94
  }
})

export const recordLabelLayerDefinition = () => ({
  id: RECORD_LABEL_LAYER_ID,
  type: 'symbol',
  source: RECORD_SOURCE_ID,
  filter: ['!', ['has', 'point_count']],
  layout: {
    'text-field': ['get', 'label'],
    'text-size': 10,
    'text-allow-overlap': true,
    'text-ignore-placement': true
  },
  paint: {
    'text-color': '#ffffff'
  }
})

const recordFeature = (kind, record, selectedRecord) => {
  const longitude = Number(record.longitude)
  const latitude = Number(record.latitude)
  if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) return null

  return {
    type: 'Feature',
    id: `${kind}:${record.id}`,
    geometry: {
      type: 'Point',
      coordinates: [longitude, latitude]
    },
    properties: {
      featureId: `${kind}:${record.id}`,
      id: record.id,
      kind,
      label: kind === 'parcel' ? (record.primary ? 'P' : '') : markerInitials(record.name),
      tone: record.health?.tone || 'slate',
      selected: Boolean(selectedRecord && selectedRecord.kind === kind && String(selectedRecord.id) === String(record.id)),
      name: kind === 'parcel' ? record.displayName : record.name
    }
  }
}
